<template>
    <div class="claim-log row">
        <div class="col-xs-12 hidden-lg hidden-md">
            <div class="claimlog-shortcuts-mobile claimlog-shortcuts__newTimeEntry">
                <i class="fa fa-plus"></i>
                <a href="#/create">Add T&E Code</a>
            </div>
        </div>
        <div class="col-xs-12 claimlog-functions">
            <div class="top-row hidden-xs">
                <div class="top-left">
                    <div class="row">
                        <div class="col-xs-3 text-right label-fixed-width">
                            <label class="search-label">Search File Notes:</label>
                        </div>
                        <div class="col-xs-9">
                            <div class="input-group no-borders search-input-group">
                                <input type="text" class="form-control" v-model="searchText"
                                       @keyup.enter="search"
                                       placeholder="Adjuster, Activity Code, Note content" />
                                <div class="input-group-addon">
                                    <button type="button" class="btn btn-primary search-button" typeof="submit" @click="search">
                                        <i class="fa fa-search"></i> Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <filter-options-desktop @change="search"></filter-options-desktop>
                </div>
                <div class="claimlog-shortcuts hidden-sm">
                    <div class="shortcut claimlog-shortcuts__newTimeEntry">
                        <a href="#/create"><i class="fa fa-plus"></i> Add T&E</a>
                    </div>
                    <div class="shortcut claimlog-shortcuts__viewDocuments">
                        <a target="KEAFilesWindow" 
                           :href="$store.state.folderUrl"
                           :data-folder-exists="$store.state.folderUrl !== 'NotFound' ? 'true' : 'false'"
                           :data-folder-archived="$store.state.folderUrl === 'Archived' ? 'true' : 'false'"
                           :data-branch-id="$store.state.branchId"
                           :data-file-id="$store.state.fileId"
                           @click.stop.prevent="handleClick"><i class="fa fa-folder"></i> Documents Folder
                        </a>
                    </div>
                    <div class="shortcut claimlog-shortcuts__generateReports">
                        <a @click="$refs.reportModal.show()"><i class="fa fa-file"></i> File notes report</a>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="claimlog-functions col-xs-12 hidden visible-xs">
                    <div class="row">
                        <div class="col-xs-12">
                            <label class="search-label">Search File Notes:</label>
                            <input type="text" class="form-control" v-model="searchText"
                                   @keyup.enter="search"
                                   placeholder="Adjuster, Activity Code, Note content" />
                        </div>
                        <div class="col-xs-12">
                            <button type="button" class="btn btn-primary search-button" typeof="submit" @click="search">
                                <i class="fa fa-search"></i> Search
                            </button>
                        </div>
                        <div class="col-xs-12">
                            <button class="btn btn-default form-control mobile-filter-button" @click="mobileFilter">
                                <i class="fa fa-filter"></i>
                                Filtering Options
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row claimlog-results-count">
                <div class="hidden-xs">
                    <sort-options-desktop @change="search"></sort-options-desktop>
                </div>
                <pagination v-if="totalPages > 1" v-model="currentPage" :total-page="totalPages" align="center" @change="setPager" />
                <div v-if="claimLog" class="col-xs-12 text-right">
                    <p v-if="claimLog.length">
                        Showing {{ options.pageSize * (currentPage - 1) + 1 }} to
                        <span v-if="currentPage < totalPages && options.pageSize != 10000">{{ options.pageSize * currentPage }}</span>
                        <span v-else> {{claimLog[0].TotalRowCount}}</span>
                        of {{claimLog[0].TotalRowCount}} entries
                    </p>
                    <p v-else>
                        No Results Found
                    </p>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div v-for="(entry, index) in claimLog" v-bind:class="[entry.BillingWorksheetId === null ? '' : 'invoiced', entry.Reversed ? 'reversed' : '', 'item-container']">
            <div v-if="entry.Id !== $store.state.editId">
                <div class="row">
                    <div class="col-xs-12 col-sm-10">
                        <h4 :class="[(entry.ActivityCode === $acConstants('OUT_KILOMETRES_CODE') && entry.IsNewTransportation) ? 'activity-code-related' : 'activity-code']" v-html="formattedCode[index]"></h4>
                    </div>
                    <div class="hidden-xs col-sm-2 invoiced-status text-right">
                        <!-- desktop invoice status -->
                        <invoice-status :entry="entry"></invoice-status>
                    </div>
                </div>
                <div v-if="entry.ActivityCode === $acConstants('OUT_KILOMETRES_CODE') && entry.IsNewTransportation" class="row">
                    <div class="col-xs-12 col-sm-10">
                        <h4 class="activity-code" v-html="formattedRelatedCode[index]"></h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6 col-sm-4 meta-data">
                        <i class="fa fa-calendar"></i>
                        <span v-html="formattedDate[index]"></span>
                        <span v-if="formattedTime[index]">
                            &nbsp;{{ formattedTime[index] }} {{entry.Timezone}}
                        </span>
                    </div>
                    <div class="col-xs-6 col-sm-4 meta-data">
                        <i class="fa fa-user"></i>
                        <span v-html="formattedAdjuster[index]"></span>
                    </div>
                    <div class="col-xs-6 col-sm-4 meta-data">
                        <span v-if="entry.Hours !== 0 && !(entry.ActivityCode === $acConstants('OUT_KILOMETRES_CODE') && entry.IsNewTransportation)">
                            <i class="fa fa-hourglass"></i>
                            {{entry.Hours}} {{entry.ActivityCodeUnits.toLowerCase()}}
                        </span>
                        <span v-else-if="entry.Units !== 0">
                            <i class="fa fa-hashtag"></i>
                            {{entry.Units}} {{entry.ActivityCodeUnits.toLowerCase()}}
                        </span>
                        <span v-else>
                            <i :class="[entry.ActivityCodeUnits.toLowerCase() === 'hours' ? 'fa fa-hourglass' : entry.ActivityCodeUnits.toLowerCase() === 'units' ? 'fa fa-hashtag' : 'fa fa-dollar-sign']"></i>
                            {{entry.Dollars}} {{entry.ActivityCodeUnits.toLowerCase()}}
                        </span>
                    </div>
                </div>
                <div v-if="entry.ActivityCode === $acConstants('OUT_KILOMETRES_CODE') && entry.IsNewTransportation" class="row">
                    <div class="col-sm-offset-8 col-xs-6 col-sm-4 meta-data">
                        <span v-if="entry.Hours !== 0">
                            <i class="fa fa-hourglass"></i>
                            {{entry.Hours}} {{entry.RelatedCodeUnits.toLowerCase()}}
                        </span>
                    </div>
                </div>
                <div class="row hidden visible-xs">
                    <div class=" col-xs-12 text-center invoiced-status invoiced-status-mobile">
                        <!-- mobile invoice status -->
                        <invoice-status :entry="entry"></invoice-status>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-10">
                        <h4 class="note-re">
                            <span v-if="entry.SendEmail">Subject:</span>
                            <span v-else>RE:</span>
                            <span v-html="formattedComment[index]"></span>
                        </h4>

                        <div class="email-metadata" v-if="entry.InvoiceId || (entry.SendEmail && entry.EmailTo && entry.EmailTo.length)">
                            <div class="row">
                                <template v-if="entry.EmailTo && entry.EmailTo.length">
                                    <div class="col-xs-3 col-sm-1 label">To:</div>
                                    <div class="col-sm-5 col-xs-9">
                                        {{ entry.EmailTo }}
                                    </div>
                                </template>
                                <template v-if="entry.InvoiceId">
                                    <div class="col-xs-3 col-sm-1 label">Invoice<span class="hidden-xs"> #</span>:</div>
                                    <div class="col-sm-5 col-xs-9">
                                        {{ entry.InvoiceId }}
                                    </div>
                                </template>
                            </div>
                            <div class="row" v-if="entry.SendEmail || (entry.ActivityCode === 'AR' && entry.RelatedToTeId != null)">
                                <div v-if="entry.SendEmail" class="col-xs-3 col-sm-1 label">From:</div>
                                <div v-if="entry.SendEmail" class="col-sm-5 col-xs-9">
                                    {{ entry.EmailFrom }}
                                </div>
                                <div class="col-xs-3 col-sm-1 label">Note:</div>
                                <div class="col-sm-5 col-xs-9">
                                    <em>
                                        email was sent through KEA 
                                        <span v-if="!entry.SendEmail">from another AR TE entry</span>
                                        <span v-if="entry.AttachInvoice">with invoice attached</span>
                                    </em>
                                </div>
                            </div>
                        </div>

                        <note-body :note-text="entry.NoteText" :teComment="entry.Comment" :collapsible="true"
                                   :excludeRE="shouldExcludeRE(entry)">
                        </note-body>
                        <div class="trigger-block" v-if="entry.TriggerCode && isAdmin">
                            <div class="row">
                                <div class="col-xs-12 col-sm-6">
                                    {{entry.TriggerCode}} - {{triggerDescription[index]}}
                                </div>
                                <div class="hidden-xs col-sm-6 trigger-note">
                                    Auto-generated for: {{entry.ActivityCode}} - {{entry.ActivityCodeDescription}}
                                    (<span v-html="formattedDate[index]"></span> by {{entry.UserName}})
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-md-2 pull-right">
                        <div class="row buttons">
                            <template v-if="!entry.Reversed && (entry.BillingWorksheetId === null || (entry.BilledDate === null && entry.ParentWorksheetId === null) || fileToBeAudited)">
                                <div class="col-xs-6 col-sm-3 col-md-12 text-center">
                                    <template v-if="entry.Id === $store.state.lastEditId">
                                        <!-- lastEditButton is used to focus & scroll after editing a record -->
                                        <button :class="['btn', 'btn-sm', 'btn-default', 'form-control', (entry.Reversed || ((entry.BillingWorksheetId || entry.AdjusterDisabled) && !fileToBeAudited)) ? 'disabled disable-edit' : '']"
                                                @click="editEntry(entry, fileToBeAudited)" ref="lastEditButton" :data-teid="entry.Id">
                                            <i class="fa fa-edit"></i>
                                            Edit
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button :class="['btn', 'btn-sm', 'btn-default', 'form-control', (entry.Reversed || entry.BillingWorksheetId || entry.AdjusterDisabled) && !fileToBeAudited ? 'disabled disable-edit' : '']"
                                                @click="editEntry(entry, fileToBeAudited)" :data-teid="entry.Id">
                                            <i class="fa fa-edit"></i>
                                            Edit
                                        </button>
                                    </template>
                                </div>
                                <div class="col-xs-6 col-sm-3 col-md-12 text-center" v-if="entry.ActivityCode != $acConstants('EMAIL_REPORT') || entry.IsLatestReport">
                                    <button :class="['btn', 'btn-sm', 'btn-default', 'form-control', entry.Reversed || entry.BillingWorksheetId ? 'disabled' : '']"
                                            @click="confirmReverse(entry.Id, entry.ActivityCode, entry.ReportNumber)">
                                        <i class="fa fa-undo"></i>
                                        Reverse
                                    </button>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div :class="['col-xs-12', 'follow-up-block', entry.FollowupResolved === 1 ? 'resolved' : '', , entry.Reversed ? 'reversed' : '']" v-if="entry.ActionItem">
                        <div class="row">
                            <div class="col-sm-2 text-sm-left text-center title">
                                <i class="fa fa-thumbtack"></i>
                                FOLLOWUP
                            </div>
                            <div class="col-sm-2 col-xs-6 text-center">
                                <i class="fa fa-calendar"></i>
                                <span v-html="followupDate[index]"></span>
                            </div>
                            <div class="col-sm-3 col-xs-6 text-center">
                                <i class="fa fa-user"></i>
                                {{entry.FollowupFirstName}} {{entry.FollowupLastName}} ({{entry.FollowupAdjuster}})
                            </div>
                            <div class="text-sm-left text-center col-sm-3 followup-action-item">
                                {{entry.ActionItem}}
                            </div>
                            <div class="text-sm-left text-center col-sm-2 action">
                                <div class="form-group">
                                    <input type="checkbox" :checked="entry.FollowupResolved === 1" @click="confirmResolve(entry.Id, entry.FollowupResolved === 1)" :id="'resolve' + index" :disabled="entry.Reversed" />
                                    <label :for="'resolve' + index">Mark as complete</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="entry.Reversed">
                    <div class="col-xs-12">
                        <h5>
                            <i class="fa fa-undo"></i>
                            Reversed by
                            {{ entry.ReversedBy }}
                            on
                            <span v-html="reversedDate[index]"></span>
                        </h5>
                    </div>
                </div>
            </div>
            <time-expense-form v-else :reload="load">
            </time-expense-form>
        </div>
        <pagination v-if="totalPages > 1" v-model="currentPage" :total-page="totalPages" align="center" @change="setPager" />
        <modal v-model="showFilterOptions" title="Filtering Options" ok-text="Apply">
            <filter-options-mobile @change="search"></filter-options-mobile>
        </modal>
        <modal v-model="showReverseConfirm" title="Confirm" @hide="closeReverseModal" ref="modal">
            <p>Reverse this entry?</p>
            <div v-if="reversedActivityCode === $acConstants('EMAIL_REPORT')">
                <p>This will:</p>
                <ul class="modal-bullet-list">
                    <li>Move the Report_{{ reportNumber }} folder and its contents into the Documents folder</li>
                    <li>Remove report number {{ reportNumber }} from the database</li>
                    <li>Undo the Report Due Date change</li>
                </ul>
            </div>
        </modal>
        <modal v-model="showResolveConfirm" title="Confirm" @hide="closeResolveModal" ref="modal" size="sm">
            <p>{{ isResolved ? 'Unresolve' : 'Resolve' }} this item?</p>
        </modal>

        <report-modal ref="reportModal"></report-modal>
    </div>
</template>
<script>
    import Vue from "vue";
    import axios from 'axios';
    import InvoiceStatus from "./invoice-status.vue";
    import ReportModal from "./report-modal.vue";
    import NoteBody from "../shared/note-body.vue";
    import FilterOptionsDesktop from "./filter-options-desktop.vue";
    import SortOptionsDesktop from "./sort-options-desktop.vue";
    import FilterOptionsMobile from "./filter-options-mobile.vue";
    import { shortDateFormat, timeFormatAMPM } from '../../_shared/date-utils';
    import { Pagination, Modal } from 'uiv';
    import { hilight } from '../../_shared/search-utils.js';
    import EditForm from '../entry-form/main-form.vue';
    import { RE_COMMENT_CUTOFF_DATE } from '../../_shared/constants';

    Vue.component("invoice-status", InvoiceStatus);
    Vue.component("note-body", NoteBody);
    Vue.component("filter-options-desktop", FilterOptionsDesktop);
    Vue.component("sort-options-desktop", SortOptionsDesktop);
    Vue.component("filter-options-mobile", FilterOptionsMobile);
    Vue.component("time-expense-form", EditForm);
    Vue.component("report-modal", ReportModal);

    export default {
        data: function () {
            return {
                claimLog: null,
                currentPage: this.$store.state.startPage,
                totalPages: 1,
                isAdmin: false,
                showFilterOptions: false,
                options: this.$store.state.searchFilter,
                searchText: "",
                reverseTimeExpenseId: 0,
                resolveTimeExpenseId: 0,
                isResolved: 0,
                showReverseConfirm: false,
                showResolveConfirm: false,
                fileToBeAudited: this.$store.state.fileToBeAudited,
                RE_COMMENT_CUTOFF_DATE: RE_COMMENT_CUTOFF_DATE,
                reversedActivityCode: null,
                reportNumber: null
            };
        },
        computed: {
            formattedDate: function () {
                return this.claimLog.map(function (item) {
                    return shortDateFormat(item.Date);
                });
            },
            formattedTime: function () {
                return this.claimLog.map(function (item) {
                    return timeFormatAMPM(item.Date, true);
                });
            },
            followupDate: function () {
                return this.claimLog.map(function (item) {
                    return shortDateFormat(item.FollowupDate);
                });
            },
            reversedDate: function () {
                return this.claimLog.map(function (item) {
                    return shortDateFormat(item.ReversedDate);
                });
            },
            triggerDescription: function () {
                return this.claimLog.map(function (item) {
                    if (item.TriggerDescription) {
                        return item.TriggerDescription.replace("Number of", "Counter Entry for");
                    } else {
                        return "";
                    }
                });
            },
            formattedComment: function () {
                let self = this;
                return this.claimLog.map(function (item) {
                    return hilight(item.Comment, self.options.searchText);
                });
            },
            formattedAdjuster: function () {
                let self = this;
                return this.claimLog.map(function (item) {
                    if (!item.AdjusterDisabled) {
                        return hilight(`${item.AdjusterFirstName} ${item.AdjusterLastName} (${item.UserName})`, self.options.searchText);
                    } else {
                        return `${item.AdjusterFirstName} ${item.AdjusterLastName} (${item.UserName}) - disabled`;
                    }
                });
            },
            formattedCode: function () {
                let self = this;
                return this.claimLog.map(function (item) {
                    const newCodePart = item.NewCode !== null
                        ? `<span class="new-code"> (New code: ${item.NewCode}) </span>`
                        : '';
                    const rawHtml = `${item.ActivityCode}${newCodePart} - ${item.ActivityCodeDescription}`;
                    return hilight(rawHtml, self.options.searchText);
                });
            },
            formattedRelatedCode: function () {
                let self = this;
                return this.claimLog.map(function (item) {
                    return hilight(`${item.RelatedCode} - ${item.RelatedCodeDesc}`, self.options.searchText);
                });
            }
        },
        methods: {
            setPager(page) {
                this.$store.state.isBillingReview = false; // exit billing review mode if this feautre is used
                this.currentPage = page;
                this.$store.state.startPage = 1;
                window.scrollTo(0, 0);
                this.load();
            },
            load() {
                let branchId = this.$store.state.branchId;
                let fileId = this.$store.state.fileId;

                if (branchId == 0 && fileId == 0) {
                    this.$router.push("/unbound");
                }

                let search = encodeURIComponent(this.options.searchText);
                let start = encodeURIComponent(shortDateFormat(this.options.startDate, "-"));
                let end = encodeURIComponent(shortDateFormat(this.options.endDate, "-"));
                let loader = this.$loading.show();
                let self = this;

                axios.get(`/core/api/timeexpenses/${branchId}/${fileId}?search=${search}&from=${start}&to=${end}&reversed=${self.options.showReversed}&clerical=${self.options.showClerical}&page-number=${self.currentPage}&page-size=${self.options.pageSize}&sort=${self.options.sortDirection}`)
                    .then(response => {
                        self.claimLog = response.data;
                        this.$store.state.editId = 0;
                        if (self.claimLog.length) {
                            self.totalPages = Math.ceil(self.claimLog[0].TotalRowCount / self.options.pageSize);
                        } else {
                            self.totalPages = 0;
                        }
                        loader.hide();
                    })
                    .catch(function (error) {
                        loader.hide();
                        console.log(error.response);
                    });
            },
            search() {
                this.$store.state.isBillingReview = false; // exit billing review mode if this feautre is used
                this.options.searchText = this.searchText;
                this.currentPage = 1;
                this.load();
            },
            mobileFilter() {
                this.showFilterOptions = true;
            },
            closeReverseModal(msg) {
                if (msg === 'ok') {
                    var url = `/core/api/timeexpenses/${this.reverseTimeExpenseId}/reversed`;
                    axios.put(url, { status: 'Reversed' })
                        .then(response => {
                            // Check if session has timed-out (detect the login page in the response).
                            if (response.request.responseURL && response.request.responseURL.toLowerCase().includes("/authentication/login")) {
                                vm.$snotify.error("Session Expired. Changes were not saved", {
                                    timeout: 3500,
                                    showProgressBar: false,
                                    closeOnClick: false,
                                    pauseOnHover: true
                                });
                            }

                            this.load();
                            vm.$snotify.success('Entry was reversed' + (this.reversedActivityCode === this.$acConstants('EMAIL_REPORT') ? ' and its report# ' + this.reportNumber + ' deleted' : ''), {
                                timeout: 1500,
                                showProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true
                            });
                        });

                    // display missing FC message
                    if (this.isCode(this.$acConstants('FIRST_CONTACT'))) {
                        $("span.fc-msg").text("First Contact Missing");
                    }
                    // For EMR, decrementing last report number in case user stays on screen which won't get it from DB
                    if (this.isCode(this.$acConstants('EMAIL_REPORT'))) {
                        this.$store.state.lastReportNumber -= 1;
                    }
                }
            },
            closeResolveModal(msg) {
                if (msg === 'ok') {
                    var url = `/core/api/filenotes/${this.resolveTimeExpenseId}/followupresolved`;
                    axios.put(url, { status: this.isResolved ? 'Unresolved' : 'Resolved', calledFromDashboard: false })
                        .then(response => {
                            // Check if session has timed-out (detect the login page in the response).
                            if (response.request.responseURL && response.request.responseURL.toLowerCase().includes("/authentication/login")) {
                                vm.$snotify.error("Session Expired. Changes were not saved", {
                                    timeout: 3500,
                                    showProgressBar: false,
                                    closeOnClick: false,
                                    pauseOnHover: true
                                });
                            }

                            this.load();
                        });
                }
            },
            confirmReverse(timeExpenseId, code, reportNumber) {
                this.$store.state.isBillingReview = false; // exit billing review mode if this feautre is used
                this.reverseTimeExpenseId = timeExpenseId;
                this.showReverseConfirm = true;
                this.reversedActivityCode = code;
                this.reportNumber = reportNumber;
            },
            confirmResolve(timeExpenseId, isResolved) {
                this.$store.state.isBillingReview = false; // exit billing review mode if this feautre is used
                this.isResolved = isResolved;
                this.resolveTimeExpenseId = timeExpenseId;
                this.showResolveConfirm = true;
            },
            editEntry(entry, fileToBeAudited) {
                this.$store.state.editId = entry.Id;
                this.$store.state.defaultUser = entry.UserName;
                this.$store.state.originalActivityCode = entry.NewCode !== null ? entry.NewCode : entry.ActivityCode;
                if (entry.ReportCycle !== null) {
                    this.$store.state.reportCycle = entry.ReportCycle;
                }
                if (entry.AbeyanceDate !== null) {
                    this.$store.state.abeyanceDate = entry.AbeyanceDate;
                }
                var date = new Date(entry.Date);
                // KII-1412: No RE anymore for non-email TEs, just comment, so for old entries combine the old RE and comment when editing
                var isLegacyTEEntry = new Date(entry.EnteredDate) < RE_COMMENT_CUTOFF_DATE;
                this.$store.state.timeEntry = {
                    id: entry.Id,
                    username: entry.UserName,
                    activityCode: entry.NewCode !== null ? entry.NewCode : entry.ActivityCode,
                    units: entry.Units,
                    dollars: entry.Dollars,
                    hours: entry.Hours,
                    date: date,
                    time: date.getHours() || date.getMinutes() ? date : new Date(''),
                    isBillable: entry.NonBillable ? "No" : "Yes",
                    comment: entry.Comment,
                    noteText: isLegacyTEEntry ? `${entry.Comment || ''}\n\n${entry.NoteText || ''}`.trim() : entry.NoteText,
                    actionItem: entry.ActionItem,
                    followupDate: entry.FollowupDate,
                    followupAdjuster: entry.FollowupAdjuster,
                    hasFollowup: entry.ActionItem && entry.ActionItem.length
                        || entry.FollowupDate !== null ? true : false,
                    timezone: entry.Timezone,
                    sendEmail: entry.NoteText === null ? "No" : (entry.SendEmail == null ? null : (entry.SendEmail ? "Yes" : "No")),
                    emailTo: entry.EmailTo,
                    attachInvoice: entry.AttachInvoice,
                    invoiceId: entry.InvoiceId,
                    isAuditEdit: (entry.BillingWorksheetId || !(entry.BilledDate === null && entry.ParentWorksheetId === null)) && fileToBeAudited,
                    isNewTransportation: entry.IsNewTransportation,
                    relatedToTeId: entry.RelatedToTeId,
                    isLegacyTEEntry: isLegacyTEEntry
                }

                this.$store.state.isBillingReview = false;
            },
            goToId() {
                var el = $("button[data-teid=" + this.$store.state.goToTeId + "]");
                if (el.length) {
                    el.focus();
                    if (this.$store.state.isBillingReview) {
                        el.click();
                        setTimeout(() => { this.$store.state.isBillingReview = true }, 200);
                    }
                    this.$store.state.goToTeId = 0;
                }
            },
            isCode: function (code) {
                return this.claimLog.map(function (item) {
                    return item.ActivityCode === code;
                });
            },
            handleClick(event) {
                // Call the global function from folderHandler.js
                handleFolderClick(event, event.currentTarget);
            },
            shouldExcludeRE(entry) {
                // KII-1412: RE is part of comment now but still displayed on File notes screen so exclude the "RE:" prefix for non-email entries created after cutoff date
                const entryDate = new Date(entry.EnteredDate);
                return (entryDate > RE_COMMENT_CUTOFF_DATE && !(entry.EmailTo || (entry.ActivityCode === 'AR' && entry.RelatedToTeId !== null)));
            }
        },
        created() {
            // check if a TeId was passed in the URL (use for deep linking to T&E entries from K90 fee breakdown and followups todo lists)
            if (this.$store.state.goToTeId) {
                setTimeout(() => this.goToId(), 500);
                setTimeout(() => this.goToId(), 100);
                setTimeout(() => this.goToId(), 1500);
                setTimeout(() => this.goToId(), 2000);
            }

            this.isAdmin = this.$store.state.isAdmin;
            this.load();
            $(".nav-category-te").removeClass('currentpage');
            $(".nav-item-claimlog").addClass('currentpage');
        },
        updated() {
            // after a use saves the "edit" form, set the focus back onto
            // the edit button for the row they edited.  This will scroll the
            // page to show the entry they just edited
            if (this.$refs.lastEditButton !== undefined) {
                if (this.$refs.lastEditButton.length) {
                    this.$refs.lastEditButton[0].focus();
                    this.$store.state.lastEditId = 0;
                }
            }
        },
        components: {
            Pagination, Modal
        },
    };
</script>
<style lang="scss">
    .new-code {
        font-size: 0.75em; /* Smaller font */
        font-weight: normal; /* Not bold */
        color: #666; /* Optional: muted color */
    }

    .modal-bullet-list {
        list-style-type: disc;
        padding-left: 20px;
        margin-left: 20px;
    }
</style>
